/* eslint-disable import/prefer-default-export */
/**
 * Check if color is a valid hexadecimal color
 *
 * @param {String} color hexadecimal color
 * @returns {Boolean} Return true if it is valid, false otherwise.
 */
export function isHexColor(color) {
  if (!color) {
    return false;
  }

  const [, hex] = color.split('#');

  return hex && typeof hex === 'string'
    && (hex.length === 6 || hex.length === 3)
    && !Number.isNaN(Number(`0x${hex}`));
}
